import { cn } from '@/lib/utils';

interface LiveBadgeProps {
    isConnected?: boolean;
    className?: string;
}

export function LiveBadge({ isConnected = false, className }: LiveBadgeProps) {
    return (
        <div
            className={cn(
                'inline-flex items-center gap-[5px] px-[5px] py-[1px] border border-grey-500 rounded',
                className,
            )}
        >
            <div
                className={cn(
                    'size-1 rounded-full',
                    isConnected
                        ? 'bg-white-100 animate-live-pulse'
                        : 'bg-grey-400',
                )}
            />
            <span
                className={cn(
                    'text-[10px] font-medium leading-4 uppercase',
                    isConnected ? 'text-grey-200' : 'text-grey-400',
                )}
            >
                Live
            </span>
        </div>
    );
}
